const callApi = async (
  endpoint,
  method = "GET",
  data = null,
  auth_required = true,
  setAlertMessage,
  isFileDownload = false,
  registrationNo = null,
  customHeaders = {},
  stringify = true,
  prefix = process.env.REACT_APP_API
) => {
  let headers = {
    ...customHeaders,
  };

  if (auth_required) {
    headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
  }

  // Don't set Content-Type for FormData or file downloads - let the browser handle it
  if (
    !isFileDownload &&
    !(data instanceof FormData) &&
    !headers["Content-Type"]
  ) {
    headers["Content-Type"] = "application/json";
  }

  try {
    const options = {
      method,
      headers,
    };

    if (data) {
      if (!stringify) {
        options.body = data;
      } else
        options.body = data instanceof FormData ? data : JSON.stringify(data);
    }

    const response = await fetch(
      `${prefix}${endpoint}`,
      options
    );

    if (!response.ok) {
      if (response.status !== 401) {
        const errorData = await response.json();
        if (setAlertMessage) {
          setAlertMessage(errorData.message || errorData.title);
        }
        return { success: false, message: errorData.message };
      }
      return { success: true, message: "" };
    }

    // Handle file download
    if (isFileDownload) {
      const contentType = response.headers.get("content-type");
      const blob = await response.blob();
      const contentDisposition = response.headers.get("content-disposition");

      let isZip = contentType === "application/zip";
      // Default filename based on content type
      let filename = `${!isZip ? registrationNo : ""}${isZip ? ".zip" : ".pdf"}`;

      // Extract filename from content-disposition if available
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      // For ZIP files, we might want to handle them differently
      if (contentType === "application/zip") {
        // Create download link and trigger click
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return {
          success: true,
          isZip: true,
          missingRegistrations:
            response.headers.get("X-Missing-Registrations")?.split(",") || [],
        };
      } else {
        // Regular file download handling (PDF, etc.)
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return { success: true };
      }
    }

    // Handle JSON response
    const responseData = await response.json();
    return { ...responseData, success: true };
  } catch (error) {
    if (setAlertMessage) {
      setAlertMessage(error.message || "An error occurred");
    }
    return { success: false, message: error.message };
  }
};

export default callApi;
